import { VacationYtdAdjustment } from '@app/models/payroll/vacation-ytd-adjuster.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class LatestTimeOffYtdBalanceColumn extends Column {
    title = 'payroll.vacation-ytds.balance';
    property = 'latestTimeOffYtdBalance';
    type: CellDisplay = CellDisplay.dollar;

    getRowStyling(vacationYtdAdjustment: VacationYtdAdjustment): { [key: string]: string } {
        if (
            vacationYtdAdjustment.latestTimeOffYtdBalance &&
            vacationYtdAdjustment.latestTimeOffYtdBalance.includes('-')
        ) {
            return { color: 'var(--error-800)' };
        }
        return { color: 'var(--success-500)' };
    }

    getDisplayPropertyValue(vacationYtdAdjustment: VacationYtdAdjustment): string {
        if (vacationYtdAdjustment.latestTimeOffYtdBalance) {
            if (vacationYtdAdjustment.latestTimeOffYtdBalance.includes('-')) {
                const strippedDollarAmount = vacationYtdAdjustment.latestTimeOffYtdBalance.replace('-', '');
                return '-' + strippedDollarAmount;
            }
            return vacationYtdAdjustment.latestTimeOffYtdBalance;
        }
        return '-';
    }
}
